// Site endpoints nested under tenant. Optional ha_instance_id bind
// on create — backend pre-validates 404/400 before the FK fires.

import { request, type ApiResponse } from "../client";
import type { SiteCreate, SiteOut } from "../types/site";

export const sites = {
  list: (
    accountSlug: string,
    tenantSlug: string,
  ): Promise<ApiResponse<SiteOut[]>> =>
    request<SiteOut[]>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites`,
    ),

  get: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
  ): Promise<ApiResponse<SiteOut>> =>
    request<SiteOut>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites/${encodeURIComponent(siteSlug)}`,
    ),

  create: (
    accountSlug: string,
    tenantSlug: string,
    body: SiteCreate,
  ): Promise<ApiResponse<SiteOut>> =>
    request<SiteOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites`,
      body,
    ),
};
